// extracted by mini-css-extract-plugin
export default {"tabs":"FinanceHistoryTabs_tabs__-anM7","tab":"FinanceHistoryTabs_tab__c-SJP","tabActive":"FinanceHistoryTabs_tabActive__wpXY2"};